import { CardIcon } from './assets/card-icon'
import { DocIcon } from './assets/doc-icon'

import cl from './style.module.scss'

export const beneData = [
	{ Icon: CardIcon, title: 'Как обычная оплата картой' },
	{ Icon: DocIcon, title: 'Без кредитного договора' }
]

export const DolyameBenes = () => {
	return (
		<div className={cl.benes}>
			{beneData.map(({ Icon, title }) => (
				<div className={cl.bene} key={title}>
					<div className={cl.icon}>
						<Icon />
					</div>
					<p className={cl.label}>{title}</p>
				</div>
			))}
		</div>
	)
}
